import React from "react";
import { Icon } from "@iconify/react";

const MetricIcon = () => (
  <Icon icon="lucide:line-chart" width={18} height={18} />
);

export default MetricIcon;
